<div class="redesign-content-container">
    <div class="header-container">
        <div class="content-container">
            <div class="process-wizard-header">
                <div class="process-wizard-stepper">
                    <!-- Create Account step-->
                    <div
                        *letVar="0 as i"
                        class="process-step step-1"
                        [ngClass]="{ active: steps[i].isActive }"
                        (click)="onTabSelectionChange(i)"
                    >
                        <div class="step-content">
                            <h3 class="step-title"><span class="step-number">1. </span>{{ steps[i].text }}</h3>
                            <div class="step-desc">{{ steps[i].description }}</div>
                        </div>
                        <div class="step-status">
                            <mat-icon *ngIf="steps[i].isCompleted" class="menu-icon fp-icon-ok_filled"></mat-icon>
                        </div>
                    </div>

                    <!-- Activate Account step-->
                    <div
                        *letVar="1 as i"
                        class="process-step step-2"
                        [ngClass]="{ active: steps[i].isActive }"
                        (click)="onTabSelectionChange(i)"
                    >
                        <div class="step-content">
                            <h3 class="step-title"><span class="step-number">2. </span>{{ steps[i].text }}</h3>
                            <div class="step-desc">{{ steps[i].description }}</div>
                        </div>
                        <div class="step-status">
                            <mat-icon *ngIf="steps[i].isCompleted" class="menu-icon fp-icon-ok_filled"></mat-icon>
                        </div>
                    </div>
                </div>
                <div class="process-wizard-action">
                    <!-- TODO -->
                    <!-- <button mat-raised-button id="btnAdd" class="new-primary-button">
                        + <ng-container i18n="@@SHARED.BTN.ADD">Create Account</ng-container>
                    </button> -->
                </div>
            </div>
        </div>
    </div>
    <div class="scrollable-content">
        <div class="content-container wizard-container">
            <!-- Create Account content-->
            <ng-container *letVar="0 as i">
                <app-create-project-wizard
                    *ngIf="steps[i].isActive"
                    class="process-step step-1"
                    [initializedData]="initializedData"
                    [isCompletingProcess]="isCompletingProcess"
                    [uuid]="uuid"
                    [existingProject]="project"
                    (completeUpdate)="onAccountCompleteUpdate()"
                ></app-create-project-wizard>
            </ng-container>

            <!-- Active Account content-->
            <ng-container *letVar="1 as i">
                <ng-container *ngIf="steps[i].isActive">
                    <div class="select-plan-container">
                        <app-activate-account
                            [project]="project"
                            [selectedPlan]="initializedData.selectedPlan"
                            [activeView]="initializedData.spView"
                            [subscription]="initializedData.subscription"
                            [isProjectOnline]="isProjectOnline"
                            [entity]="entity"
                            [customer]="user"
                            [isServicePlanSelected]="isServicePlanSelected"
                            (updateDone)="onAccountCompleteActivate($event)"
                            (navigateEditUser)="onNavigateEditUser()"
                        ></app-activate-account>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>
